import React from 'react';
import { Drawer, Toolbar, Typography, List } from '@mui/material';
import { WIDGET_DEFINITIONS, DRAWER_WIDTH } from '../constants';
import { WidgetPaletteItem } from './WidgetPaletteItem';

interface WidgetPaletteProps {
    open: boolean;
}

export const WidgetPalette: React.FC<WidgetPaletteProps> = ({ open }) => {
    return (
        <Drawer
            variant="persistent"
            anchor="right"
            open={open}
            sx={{
                width: DRAWER_WIDTH,
                position: 'absolute',
                flexShrink: 0,
                '& .MuiDrawer-paper': {
                    width: DRAWER_WIDTH,
                    boxSizing: 'border-box'
                }
            }}
        >
            <Toolbar>
                <Typography variant="h6">Widget Palette</Typography>
            </Toolbar>
            <List>
                {WIDGET_DEFINITIONS.map((definition) => (
                    <WidgetPaletteItem key={definition.type} definition={definition} />
                ))}
            </List>
        </Drawer>
    );
};